"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
/**
 * Each of the attributes contains the translation in that language of the Label.
 *
 * Example:
 * ```
 * name.it: 'ciao';
 * name.en: 'hello';
 * ```
 */
class Label {
    constructor(x, languages) {
        this.load(x, languages);
    }
    load(x, languages) {
        if (x)
            languages.available.forEach(l => (this[l] = x[l] ? String(x[l]) : null));
        else
            languages.available.forEach(l => (this[l] = null));
    }
    validate(languages) {
        if (!this[languages.default])
            return [languages.default];
        else
            return [];
    }
    /**
     * Translate the label in the desired language; in case there's no translation, get the default one.
     */
    translate(language, languages) {
        return this[language] || this[languages.default];
    }
}
exports.Label = Label;
